// extracted by mini-css-extract-plugin
export default {"header":"panelheader_header__aJBbB","reward":"panelheader_reward__Y5pI1","store":"panelheader_store__Emgfz","sel":"panelheader_sel__lmCL5"};